import { useCallback, useEffect, useState } from 'react';

import Loader from '../../../components/Loader';
import SimpleTable from '../../../components/SimpleTable';
import { Exam, ExamChangeLog } from '../../../types';
import ExamRepository from '../repository/ExamRepository';
import {
  COLUMN_EXAM_CHANGE_LOG_ACTOR,
  COLUMN_EXAM_CHANGE_LOG_CONTEXT,
  COLUMN_EXAM_CHANGE_LOG_TIMESTAMP,
  COLUMN_EXAM_CHANGE_LOG_TYPE,
} from '../domain/columns';

interface ExamChangeLogsProps {
  exam: Exam;
}

const ExamChangeLogs = (props: ExamChangeLogsProps) => {
  const [changeLogs, setChangeLogs] = useState<ExamChangeLog[] | undefined>(
    undefined,
  );

  const columns = [
    COLUMN_EXAM_CHANGE_LOG_TIMESTAMP,
    COLUMN_EXAM_CHANGE_LOG_ACTOR,
    COLUMN_EXAM_CHANGE_LOG_TYPE,
    COLUMN_EXAM_CHANGE_LOG_CONTEXT,
  ];

  const loadDeclarations = useCallback(() => {
    new ExamRepository()
      .getChangeLogs(props.exam.id)
      .then((response) => setChangeLogs(response.data));
  }, [props.exam.id]);

  useEffect(() => {
    loadDeclarations();
  }, [loadDeclarations]);

  if (changeLogs === undefined) {
    return <Loader />;
  }

  return <SimpleTable items={changeLogs} columns={columns} />;
};

export default ExamChangeLogs;
